import React from "react";
import {Container} from "@mui/material";
import {PartnerTextGrid} from "./styles";
import {CardContentInfo} from './CustomerText';

export const PartnerText = () => {
    const contents = [
        {
            image: "https://static.secur.space/icons/security.png",
            title: "Track Requests",
            description: "SecurSpace will automatically send you requests from Buyers who want to book your location! You have 30 minutes to respond to these requests."
        },
        {
            image: "https://static.secur.space/icons/calendar.png",
            title: "Sign Up For Instant Approval",
            description: "Talk to a SecurSpace team member to set up your account on auto-pilot! Our system can manage your extra spaces and track this for you!"
        },
        {
            image: "https://static.secur.space/icons/global.png",
            title: "Keep Us Informed",
            description: "Did you move? Grow? Downsize? Let us know so we can ensure you're maximizing parking and storage revenue! Many of our Suppliers also use us to find flexible real estate solutions in new cities so reach out if this is something we can help you with!"
        },
    ]

    return (
        <Container maxWidth="lg" className="ss-customer-text">
            <PartnerTextGrid
                container
                direction="row"
                alignItems="flex-start"
                justifyContent="space-between"
            >
                {contents.map((item, index) => (
                    <CardContentInfo key={index} {...item} />
                ))}
            </PartnerTextGrid>
        </Container>
    )
}
